var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelSvgrepoPickup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_1293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51807 13.7201C8.22767 14.1978 9.08133 14.4771 9.99927 14.4771C12.4551 14.4771 14.4531 12.479 14.4531 10.0232C14.4531 9.10526 14.1739 8.25159 13.6961 7.54199L7.51807 13.7201Z",
    fill: "#C43232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99928 5.56934C7.54334 5.56934 5.54541 7.56727 5.54541 10.0232C5.54541 11.0629 5.90434 12.0196 6.50368 12.7783L12.7542 6.52774C11.9957 5.92827 11.0389 5.56934 9.99928 5.56934Z",
    fill: "#C43232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9996 0C4.477 0 0 4.4774 0 9.9998C0 15.5222 4.477 20 9.9996 20C15.5222 20 19.9996 15.5225 19.9996 9.9998C19.9996 4.47713 15.5223 0 9.9996 0ZM9.9998 15.8605C6.78113 15.8605 4.16267 13.2418 4.16267 10.0233C4.16267 6.80467 6.78113 4.1862 9.9998 4.1862C13.2183 4.1862 15.8369 6.80467 15.8369 10.0233C15.8369 13.2418 13.2183 15.8605 9.9998 15.8605Z",
    fill: "#C43232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_1293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSvgrepoPickup);
export default __webpack_public_path__ + "static/media/cancel-svgrepo-pickup.a1026fd9.svg";
export { ForwardRef as ReactComponent };